var app = angular.module("leonardo");

var DashboardController = function ($scope, uiGmapGoogleMapApi, PropertyService, FilterService, $rootScope, $timeout,
                                    $state, AuthDataService, $filter, $interval, RecurrenceService, TemplateService, $q,
                                    ngDialog, AccountUserService, PermissionService, NotificationService, ReportService,
                                    ConfigThemeService, UtilityService) {

  $scope.lon = null;
  $scope.lat = null;
  $scope.geocoder = null;
  $scope.updating = false;
  $scope.markers = [];
  $scope.address = 'Los Angeles, California, USA';
  $scope.tab = 'past';
  $scope.templateService = TemplateService;
  $scope.accountUserService = AccountUserService;
  $scope.permissionService = PermissionService;
  $scope.zoom_device = detectZoom.zoom();

  $scope.myGoogleMap = {};

  $scope.last_activity_test = [
    { property: "Lakeview Towers", user: "Erin Boley", lastactivity: "Completed Morning Property Walk" },
    { property: "Liberty Place", user: "Kaila Charles", lastactivity: "Completed Monthly Safety Meeting" },
    { property: "Mira Vista Costa", user: "Dererk Pardon", lastactivity: "Completed Property Lighting Audit" },
    { property: "Sandelwood Gardens", user: "Natalie Chou", lastactivity: "Completed Quaterly Safety Inspection" },
    { property: "Sundance Terrace", user: "Lindsey Corsaro", lastactivity: "Completed Morning Property Walk" },
    { property: "Warring Street Lofts", user: "Charlie Hall", lastactivity: "Completed Beginning-of-day Procedures" },
    { property: "Highline Colonnade", user: "Crystal Dangerfield", lastactivity: "Completed Submit Payroll Approvals" },
    { property: "Forest Hill", user: "Joyner Holmes", lastactivity: "Created a Note " },
    { property: "Sun Glen Apartments", user: "Ciera Johnson", lastactivity: "Completed Dynamic Form Daily Pool pH" },
    { property: "Hidden Lake", user: "Isiah Brown", lastactivity: "Logged in" },
    { property: "Watertower Mews", user: "Nancy Mulkey", lastactivity: "Completed Annual Fire Safety Inspection" },
    { property: "Sycamore Homes", user: "Amber Ramirez", lastactivity: "Created a Note " },
    { property: "Casa Grande Villas", user: "Alecia Sutton", lastactivity: "Updated expired document Landscape Contract" },
    { property: "The Pointe at Cedar Lane", user: "Blair Watson", lastactivity: "Completed Post Craigslist Ads" },
    { property: "Greenleaf Highlands", user: "Scottie Lindsey", lastactivity: "Completed Daily Property Walk" },
    { property: "Monterey Tower", user: "Aaliyah Wilson", lastactivity: "Completed Staff Schedule for Coming Month" },
    { property: "Laurel Crossing", user: "Jeannie Boehm", lastactivity: "Completed Check Handrails" },
    { property: "Cotton Ridge", user: "Tino Malnati", lastactivity: "Completed Daily Trash Area Maintenance" },
    { property: "La Serranada", user: "DiJonai Carrington", lastactivity: "Completed Check on Status of Work Orders older than 48 hours" },
    { property: "Austin Crossing", user: "Chassity Carter", lastactivity: "Logged In" },
    { property: "Villa Esmerelda", user: "Lauren Cox", lastactivity: "Completed Submit Delinquency Report to Corporate" },
    { property: "Glenoaks Manor", user: "Jordan Ash", lastactivity: "Created a Note " },
    { property: "Hillside Gardens", user: "Nadia Fingall", lastactivity: "Updated Expired Document Insurance - Otis Elevator" },
    { property: "Lakeview Towers", user: "Sabrina Ionescu", lastactivity: "Completed Monthly Leasing Training" },
    { property: "Liberty Place", user: "Barret Benson", lastactivity: "Completed Walk Property for Trip Hazards" },
    { property: "Mira Vista Costa", user: "Tori McCoy", lastactivity: "Logged in" },
    { property: "Sandelwood Gardens", user: "Leaonna Odom", lastactivity: "Completed Daily Staff Meeting" },
    { property: "Sundance Terrace", user: "Bryant McIntosh", lastactivity: "Completed Check Emergency Supplies" },
    { property: "Warring Street Lofts", user: "Kylee Shook", lastactivity: "Completed Month End Pre-close Procedures" },
    { property: "Highline Colonnade", user: "Destiny Slocum", lastactivity: "Completed Submit Concession Report" },
    { property: "Forest Hill", user: "Anna Wilson", lastactivity: "Completed Post Craigslist Ads" },
    { property: "Sun Glen Apartments", user: "Jackie Young", lastactivity: "Completed Daily Property Walk" },
    { property: "Hidden Lake", user: "Nathan Taphorn", lastactivity: "Completed Plan Monthly Resident Event" },
    { property: "Watertower Mews", user: "Ellie Bryant", lastactivity: "Created a Note " },
    { property: "Sycamore Homes", user: "Annika Prins", lastactivity: "Completed Post to Social Media" },
    { property: "Casa Grande Villas", user: "Sanjay Lumpkin", lastactivity: "Completed Check Laundry Dryer Lint" },
    { property: "The Pointe at Cedar Lane", user: "Eva Richards", lastactivity: "Completed Issue Small Balance Letters" },
    { property: "Greenleaf Highlands", user: "Aaron Falzon", lastactivity: "Logged in" },
    { property: "Monterey Tower", user: "Kathryn Roberts", lastactivity: "Completed Inspect Pool Gates" },
    { property: "Laurel Crossing", user: "Olivia Norton", lastactivity: "Completed Roof Annual Inspection" },
    { property: "Cotton Ridge", user: "Chris Collins", lastactivity: "Completed Respond to Online Ratings Comments" },
    { property: "La Serranada", user: "Montana Jones", lastactivity: "Completed Daily Pool pH Monitoring" },
    { property: "Austin Crossing", user: "Patrick Baldwin", lastactivity: "Completed Issue 3-Day Notices " },
    { property: "Villa Esmerelda", user: "Aubrey Baker", lastactivity: "Completed Semi-Annual Balcony Inspection" },
    { property: "Glenoaks Manor", user: "Ann-Marie Jacobs", lastactivity: "Completed Quaterly HVAC Filter Change" },
    { property: "Hillside Gardens", user: "Brian James", lastactivity: "Created a Note " },
    { property: "Lakeview Towers", user: "Ali Jochums", lastactivity: "Completed Inspect Stairways for Blockages" },
    { property: "Liberty Place", user: "Chris Lauten", lastactivity: "Completed Weekly Landscape Checklist" },
    { property: "Mira Vista Costa", user: "Kate Parrish", lastactivity: "Completed Submit Bonus Commissions for Approval" },
    { property: "Sandelwood Gardens", user: "Carlie Gilbert", lastactivity: "Completed Daily Pool pH Monitoring" },
    { property: "Sandelwood Gardens", user: "Carlie Gilbert", lastactivity: "Completed Dyanmic Form Daily Pool pH Monitoring" },
    { property: "Sundance Terrace", user: "Tad Glibert", lastactivity: "Completed Lease Expiration Report Due to Regional" },
    { property: "Glenoaks Manor", user: "Jordan Ash", lastactivity: "Completed Storage Room Inspection" },
    { property: "Hillside Gardens", user: "Nadia Fingall", lastactivity: "Completed Reconcile Petty Cash" },
    { property: "Lakeview Towers", user: "Sabrina Ionescu", lastactivity: "Logged in" },
    { property: "Liberty Place", user: "Barret Benson", lastactivity: "Completed Check For Loose Handrails" },
    { property: "Mira Vista Costa", user: "Tori McCoy", lastactivity: "Completed HVAC Filters Change" },
    { property: "Sandelwood Gardens", user: "Leaonna Odom", lastactivity: "Completed Annual Unit Interior Inspection" },
    { property: "Sundance Terrace", user: "Bryant McIntosh", lastactivity: "Completed Property Walk - Daily" },
    { property: "Warring Street Lofts", user: "Kylee Shook", lastactivity: "Completed Post Available Units" },
    { property: "Highline Colonnade", user: "Destiny Slocum", lastactivity: "Completed Check Apartmentratings.com for Reviews" },
    { property: "Forest Hill", user: "Anna Wilson", lastactivity: "Completed Post to Property Facebook Page" },
    { property: "Sun Glen Apartments", user: "Jackie Young", lastactivity: "Created a Note " },
    { property: "Hidden Lake", user: "Nathan Taphorn", lastactivity: "Completed End-of-Day Procedures" },
    { property: "Watertower Mews", user: "Ellie Bryant", lastactivity: "Completed Check Model Units" },
    { property: "Warring Street Lofts", user: "Kylee Shook", lastactivity: "Completed Log In to Grace Hill For Fair Housing Training" },
    { property: "Highline Colonnade", user: "Destiny Slocum", lastactivity: "Logged in" },
    { property: "Forest Hill", user: "Anna Wilson", lastactivity: "Completed Deliver Rent Demand Notices" },
    { property: "Sun Glen Apartments", user: "Jackie Young", lastactivity: "Completed Post Late Fees" },
    { property: "Cotton Ridge", user: "Chris Collins", lastactivity: "Completed Vacant Unit Inspections" }
  ];
  $scope.last_activity_report = [];
  $scope.properties = [];

  $scope.semaphore = false;
  $scope.showSettings = function () {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/overview/settings.html',
      className: 'ngdialog-theme-default',
      controller: 'SettingsMapController'
    }).then(function () {
      $scope.closeInfo();
      $scope.refresh();
    });
  };

  $scope.icons = {
    empty: 'img/icon-marker-empty.png',
    empty_active: 'img/icon-marker-empty-active.png',
    ok: 'img/icon-marker-ok.png',
    ok_active: 'img/icon-marker-ok-active.png',
    warning: 'img/icon-marker-warning.png',
    warning_active: 'img/icon-marker-warning-active.png',
    error: 'img/icon-marker-error.png',
    error_active: 'img/icon-marker-error-active.png'
  };

  $scope.getIcon = function (property) {
    if (property.tasks_statistics.total.total.total === 0) {
      return $scope.icons.ok;
    }
    var icon = $scope.icons.error;
    var value = property.progress_status;
    if (value == PropertyService.PROGRESS_STATUS_OK) {
      icon = $scope.icons.ok;
    }
    else if (value == PropertyService.PROGRESS_STATUS_WARNING) {
      icon = $scope.icons.warning;
    }
    return icon;
  };

  $scope.getIconActive = function (property) {
    if (property.tasks_statistics.total.total.total === 0) {
      return $scope.icons.ok_active;
    }
    var icon = $scope.icons.error_active;
    var value = property.progress_status;
    if (value == PropertyService.PROGRESS_STATUS_OK) {
      icon = $scope.icons.ok_active;
    }
    else if (value == PropertyService.PROGRESS_STATUS_WARNING) {
      icon = $scope.icons.warning_active;
    }
    return icon;
  };

  $scope.setInfo = function (index) {
    $scope.showHelp = false;
    $scope.tab = 'past';
    var filters = {
      account: FilterService.getFilter('account_reports'),
      priority: FilterService.getFilter('priority'),
      category: FilterService.getFilter('category'),
      id: FilterService.getFilter('property_reports'),
      group: FilterService.getFilter('group_reports'),
      portfolio: FilterService.getFilter('portfolio_reports'),
      managed_by: FilterService.getFilter('managed_by_reports'),
      property_status: FilterService.getFilter('property_status')
    };
    filters.id = $scope.markers[index].property.id;
    PropertyService.getPastDue(filters).then(function (data) {
      $scope.marker = data.results ? data.results[0] : data[0];
      angular.forEach($scope.markers, function (marker) {
        marker.options.icon = $scope.getIcon(marker.property);
      });
      $scope.markers[index].options.icon = $scope.getIconActive($scope.markers[index].property);
      if ($scope.myGoogleMap) {
        $scope.myGoogleMap.getGMap().panTo(new google.maps.LatLng($scope.marker.latitude, $scope.marker.longitude));
        var zoom = $scope.myGoogleMap.getGMap().getZoom();
        var zoom_device = detectZoom.zoom();
        if ($scope.zoom_device !== zoom_device) {
          var zoom_change = $scope.zoom_device > zoom_device ? 1 : -0.5;
          $scope.zoom_device = zoom_device;
          $scope.myGoogleMap.getGMap().setZoom(zoom+zoom_change);
        }
      }
    });
  };

  $scope.closeInfo = function () {
    $scope.marker = null;
    $scope.showHelp = false;
    angular.forEach($scope.markers, function (marker) {
      marker.options.icon = $scope.getIcon(marker.property);
    });
  };

  $scope.indexMarker = function () {
    var index = -1;
    if ($scope.marker)
      angular.forEach($scope.markers, function (marker, key) {
        if (marker.property.id == $scope.marker.id)
          index = key;
      });
    return index;
  };

  $scope.goTo = function (location, priority) {
    $rootScope.$broadcast('no_reset_filters:updated', true);
    if (!isNull(priority)) {
      FilterService.setFilter('priority', priority.toString());
    }
    FilterService.setProperty($scope.marker.id).then(function (){
      $state.go(location);
    });
  };

  $scope.goToExpired = function (property) {
    $rootScope.$broadcast('no_reset_filters:updated', true);
    if (property) {
      FilterService.setProperty(property).then(function (){
        $state.go('documents.expired');
      });
    }
  };

  $scope.showTab = function (tab) {
    if ($scope.updating) {
      return;
    }
    $scope.showHelp = false;
    $scope.tab = tab;
    var filters = {
      account: FilterService.getFilter('account_reports'),
      priority: FilterService.getFilter('priority'),
      category: FilterService.getFilter('category'),
      id: FilterService.getFilter('property_reports'),
      group: FilterService.getFilter('group_reports'),
      portfolio: FilterService.getFilter('portfolio_reports'),
      managed_by: FilterService.getFilter('managed_by_reports'),
      property_status: FilterService.getFilter('property_status')
    };
    if ($scope.marker) {
      filters.id = $scope.marker.id;
    }
    switch (tab) {
      case 'current':
        PropertyService.getStatistics(filters).then(function (data) {
          setmarker(data);
        }, function () {
          $scope.updating = false;
        });
        break;
      case 'past':
        PropertyService.getPastDue(filters).then(function (data) {
          setmarker(data);
        }, function () {
          $scope.updating = false;
        });
        break;
      case 'history':
        if (FilterService.hasFilter('date_range')) {
          filters.date_range = FilterService.getFilter('date_range');
        }
        else if (FilterService.hasFilter('from_date') || FilterService.hasFilter('to_date')) {
          filters.from_date = FilterService.getFilter('from_date');
          filters.to_date = FilterService.getFilter('to_date');
        }
        else {
          $scope.date_range = 'last_30_days';
          FilterService.setFilter('date_range', 'last_30_days');
          return;
        }
        PropertyService.getHistory(filters).then(function (result) {
          $scope.historyAll = {
            series: ['All'],
            labels: [],
            data: [],
            options: {
              title: {
                display: true,
                text: 'All Tasks %'
              },
              elements: {
                point: {
                  backgroundColor: 'rgba(42, 57, 78, 0.1)',
                  borderColor: 'rgba(42, 57, 78, 1)'
                },
                line: {
                  borderColor: 'rgba(42, 57, 78, 1)',
                  backgroundColor: 'rgba(42, 57, 78, 0.1)'
                }
              },
              scales: {
                xAxes: [{
                  ticks: {
                    display: false
                  }
                }],
                yAxes: [{
                  ticks: {
                    beginAtZero: true,
                    min: 0,
                    max: 100
                  }
                }]
              }
            }
          };
          $scope.historyCritical = {
            series: ['Critical'],
            labels: [],
            data: [],
            options: {
              title: {
                display: true,
                text: 'Critical Tasks %'
              },
              elements: {
                point: {
                  backgroundColor: 'rgba(42, 57, 78, 0.1)',
                  borderColor: 'rgba(42, 57, 78, 1)'
                },
                line: {
                  borderColor: 'rgba(42, 57, 78, 1)',
                  backgroundColor: 'rgba(42, 57, 78, 0.1)'
                }
              },
              scales: {
                xAxes: [{
                  ticks: {
                    display: false
                  }
                }],
                yAxes: [{
                  ticks: {
                    beginAtZero: true,
                    min: 0,
                    max: 100
                  }
                }]
              }
            }
          };
          $scope.historyDaily = {
            series: ['Daily'],
            labels: [],
            data: [],
            options: {
              title: {
                display: true,
                text: 'Daily Tasks %'
              },
              elements: {
                point: {
                  backgroundColor: 'rgba(42, 57, 78, 0.1)',
                  borderColor: 'rgba(42, 57, 78, 1)'
                },
                line: {
                  borderColor: 'rgba(42, 57, 78, 1)',
                  backgroundColor: 'rgba(42, 57, 78, 0.1)'
                }
              },
              scales: {
                xAxes: [{
                  ticks: {
                    display: false
                  }
                }],
                yAxes: [{
                  ticks: {
                    beginAtZero: true,
                    min: 0,
                    max: 100
                  }
                }]
              }
            }
          };
          $scope.historyWeekly = {
            series: ['Weekly'],
            labels: [],
            data: [],
            options: {
              title: {
                display: true,
                text: 'Weekly Tasks %'
              },
              elements: {
                point: {
                  backgroundColor: 'rgba(42, 57, 78, 0.1)',
                  borderColor: 'rgba(42, 57, 78, 1)'
                },
                line: {
                  borderColor: 'rgba(42, 57, 78, 1)',
                  backgroundColor: 'rgba(42, 57, 78, 0.1)'
                }
              },
              scales: {
                xAxes: [{
                  ticks: {
                    display: false
                  }
                }],
                yAxes: [{
                  ticks: {
                    beginAtZero: true,
                    min: 0,
                    max: 100
                  }
                }]
              }
            }
          };
          $scope.historyMonthly = {
            series: ['Monthly'],
            labels: [],
            data: [],
            options: {
              title: {
                display: true,
                text: 'Monthly Tasks %'
              },
              elements: {
                point: {
                  backgroundColor: 'rgba(42, 57, 78, 0.1)',
                  borderColor: 'rgba(42, 57, 78, 1)'
                },
                line: {
                  borderColor: 'rgba(42, 57, 78, 1)',
                  backgroundColor: 'rgba(42, 57, 78, 0.1)'
                }
              },
              scales: {
                xAxes: [{
                  ticks: {
                    display: false
                  }
                }],
                yAxes: [{
                  ticks: {
                    beginAtZero: true,
                    min: 0,
                    max: 100
                  }
                }]
              }
            }
          };
          if (result.length > 0) {
            $scope.marker = result[0];
            var date = '';
            angular.forEach($scope.marker.tasks_statistics.critical, function (statistic, key) {
              date = moment(key, 'YYYYMMDD').format('MMM YYYY');
              $scope.historyCritical.labels.push(date);
              $scope.historyCritical.data.push($filter('number')(statistic.percent_completed, 0));
            });
            angular.forEach($scope.marker.tasks_statistics.total, function (statistic, key) {
              $scope.historyAll.labels.push(moment(key, 'YYYYMMDD').format('MMM YYYY'));
              $scope.historyAll.data.push($filter('number')(statistic.percent_completed, 0));
            });
            angular.forEach($scope.marker.tasks_statistics.daily, function (statistic, key) {
              $scope.historyDaily.labels.push(moment(key, 'YYYYMMDD').format('MMM DD, YYYY'));
              $scope.historyDaily.data.push($filter('number')(statistic.percent_completed, 0));
            });
            angular.forEach($scope.marker.tasks_statistics.weekly, function (statistic, key) {
              var label = moment(key, 'YYYYMMDD').format('MMM YYYY') + ', ' +
                RecurrenceService.getWeek(moment(key, 'YYYYMMDD')) + ' week';
              $scope.historyWeekly.labels.push(label);
              $scope.historyWeekly.data.push($filter('number')(statistic.percent_completed, 0));
            });
            angular.forEach($scope.marker.tasks_statistics.monthly, function (statistic, key) {
              $scope.historyMonthly.labels.push(moment(key, 'YYYYMMDD').format('MMM YYYY'));
              $scope.historyMonthly.data.push($filter('number')(statistic.percent_completed, 0));
            });
          }
          $scope.updating = false;
        }, function () {
          $scope.updating = false;
        });
        break;
      default:
        $scope.updating = false;
        break;
    }
  };

  function setmarker(data) {
    var results = data.results ? data.results : data;
    if (results.length > 0) {
      $scope.marker = results[0];
    }
    $scope.updating = false;
  }

  $scope.getValue = function (status) {
    if (!status) return;
    var value = status.percent_completed;
    if ((status.completed == 0) && (status.total == 0)) {
      value = 0;
    }
    return value / 100;
  };

  $scope.getOptions = function (status, incolor) {
    if (!status) {
      return;
    }
    var options = {
      strokeWidth: 6,
      trailColor: ConfigThemeService.getColor('tertiaryColor', 0.2),
      color: (incolor || (status.total === 0)) ? ConfigThemeService.getColor('tertiaryColor', 0.2) : ConfigThemeService.config.theme_config.errorColor
    };
    if (!incolor && (status.total > 0)) {
      var value = status.progress_status;
      if (value == PropertyService.PROGRESS_STATUS_OK) {
        options['color'] = ConfigThemeService.config.theme_config.successColor;
      }
      else if (value == PropertyService.PROGRESS_STATUS_WARNING) {
        options['color'] = ConfigThemeService.config.theme_config.warningColor;
      }
    }
    return options;
  };

  $scope.getText = function (status) {
    if (!status) {
      return;
    }
    var value = status.percent_completed + '%';
    if ((status.completed == 0) && (status.total == 0)) {
      value = 'N/A';
    }
    return value;
  };

  $scope.goToActivity = function (mia) {
    var filters = [];
    FilterService.setFilter('from_date', moment().subtract(5, 'days').format('YYYY-MM-DD'), true);
    filters.push('from_date');
    FilterService.setFilter('to_date', moment().format('YYYY-MM-DD'), true);
    filters.push('to_date');
    if (mia) {
      FilterService.setFilter('mia', 1, true);
      filters.push('mia');
    }
    if (FilterService.hasFilter('property_reports')) {
      filters.push('property_reports');
    }
    else if (FilterService.hasFilter('portfolio_reports')) {
      filters.push('portfolio_reports');
    }

    FilterService.setFilter('filters', filters, true);
    ReportService.setQuickReport({ name: "Launch Activity Report", filters: filters });
    $rootScope.$broadcast('no_reset_filters:updated', true);
    $state.go('reports.activity');
  };

  $scope.refreshMarkers = function (results, notClose) {
    $scope.markers = [];
    $scope.loading = false;
    $timeout(function () {
      angular.forEach(results, function (result, key) {
        if (result.loading) {
          $scope.loading = true;
        }
        var marker = {
          id: key + 1,
          coords: {
            latitude: result.latitude,
            longitude: result.longitude
          },
          options: {
            icon: ($scope.marker && (result.id == $scope.marker.id)) ?
              $scope.getIconActive(result) : $scope.getIcon(result)
          },
          control: {},
          property: result
        };
        $scope.markers.push(marker);
      });
      if (notClose && ($scope.indexMarker() !== -1)) {
        var filters = {
          account: FilterService.getFilter('account_reports'),
          priority: FilterService.getFilter('priority'),
          category: FilterService.getFilter('category'),
          id: FilterService.getFilter('property_reports'),
          group: FilterService.getFilter('group_reports'),
          portfolio: FilterService.getFilter('portfolio_reports'),
          managed_by: FilterService.getFilter('managed_by_reports'),
          property_status: FilterService.getFilter('property_status'),
        };
        filters.id = $scope.markers[$scope.indexMarker()].property.id;
        PropertyService.getPastDue(filters).then(function (data) {
          $scope.marker = data.results ? data.results[0] : data[0];
          $scope.showTab($scope.tab);
          $scope.semaphore = false;
        });
      }
      else {
        $scope.closeInfo();
        $timeout(function () {
          var bounds = new google.maps.LatLngBounds();
          if ($scope.markers.length > 0) {
            angular.forEach($scope.markers, function (marker) {
              if (Object.keys(marker.control).length > 0) {
                bounds.extend(marker.control.getGMarkers()[0].getPosition());
              }
            });
            if ($scope.myGoogleMap) {
              $scope.myGoogleMap.getGMap().fitBounds(bounds);
              if ($scope.myGoogleMap.getGMap().getZoom() > 15) {
                $scope.myGoogleMap.getGMap().setZoom(15);
              }
            }
          }
          else if ($scope.myGoogleMap) {
            bounds = $scope.myGoogleMap.getGMap().getBounds();
            $scope.myGoogleMap.getGMap().fitBounds(bounds);
            $scope.myGoogleMap.getGMap().setZoom(2);
          }
          $scope.semaphore = false;
        }, 500);
      }
    }, 0);
  };

  $scope.refresh = function (notClose) {
    if ($scope.semaphore) {
      return;
    }
    $scope.semaphore = true;
    var filters = {
      account: FilterService.getFilter('account_reports'),
      priority: FilterService.getFilter('priority'),
      category: FilterService.getFilter('category'),
      id: FilterService.getFilter('property_reports'),
      group: FilterService.getFilter('group_reports'),
      portfolio: FilterService.getFilter('portfolio_reports'),
      managed_by: FilterService.getFilter('managed_by_reports'),
      property_status: FilterService.getFilter('property_status'),
      limit: 8
    };
    var promises = [];
    promises.push(PropertyService.getActivity(filters, true).then(function (results) {
      $scope.last_activity_report = results.results ? results.results : results;
    }));
    delete(filters.limit);
    filters.summary = true;
    filters.disable_pagination = true;
    promises.push(PropertyService.getPastDue(filters, true).then(function (results) {
      $scope.properties = results.results ? results.results : results;
      $scope.refreshMarkers($scope.properties, notClose);
    }));
    $q.all(promises).then(function () {
      openDialog();
    }, function () {
      openDialog();
    });
  };

  function openDialog() {
    if (($scope.last_activity_report.length === 0) && ($scope.properties.length === 0)) {
      ngDialog.open({ template: 'views/templates/dialog/no-results.html' });
    }
  }

  uiGmapGoogleMapApi.then(function (maps) {
    $scope.geocoder = new maps.Geocoder();
    $scope.status_ok = maps.GeocoderStatus.OK;
    $scope.lat = 34.0522;
    $scope.lon = -118.2437;

    $scope.options = {
      disableDefaultUI: true,
      zoomControl: true,
      zoomControlOptions: {
        position: google.maps.ControlPosition.LEFT_BOTTOM
      },
      scrollwheel: false,
      styles: [
        {
          "featureType": "water",
          "stylers": [
            {
              "visibility": "on"
            },
            {
              "color": "#b5cbe4"
            }
          ]
        },
        {
          "featureType": "landscape",
          "stylers": [
            {
              "color": "#efefef"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#83a5b0"
            }
          ]
        },
        {
          "featureType": "road.arterial",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#bdcdd3"
            }
          ]
        },
        {
          "featureType": "road.local",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#ffffff"
            }
          ]
        },
        {
          "featureType": "poi.park",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#e3eed3"
            }
          ]
        },
        {
          "featureType": "administrative",
          "stylers": [
            {
              "visibility": "on"
            },
            {
              "lightness": 33
            }
          ]
        },
        {
          "featureType": "road"
        },
        {
          "featureType": "poi.park",
          "elementType": "labels",
          "stylers": [
            {
              "visibility": "on"
            },
            {
              "lightness": 20
            }
          ]
        },
        {},
        {
          "featureType": "road",
          "stylers": [
            {
              "lightness": 20
            }
          ]
        }
      ]
    };

    $scope.config = {
      create: false
    };
    var zoom = 6;
    $scope.map = {
      center: { latitude: $scope.lat, longitude: $scope.lon },
      zoom: zoom,
      options: $scope.options,
      markers: $scope.markers,
      events: {
        click: function (mapModel, eventName, originalEventArgs) {
          $scope.closeInfo();
        }
      }
    };
    $timeout(function () {
      $scope.refresh();
    }, 100);
  }, function (error) {
    NotificationService.error(error);
  });

  $scope.refreshActivity = function () {
    var user = Math.floor(UtilityService.randomFloat() * 69);
    var activity = Math.floor(UtilityService.randomFloat() * 69);
    angular.forEach($scope.last_activity_report, function (report) {
      report.className = '';
    });
    $scope.last_activity_report.splice(0, 0, {
      name: $scope.last_activity_test[user].property,
      last_activity: {
        account_user: {
          user: {
            first_name: $scope.last_activity_test[user].user
          }
        },
        datetime_done: moment().format('MMMM DD, YYYY - HH:mm'),
        description: $scope.last_activity_test[activity].lastactivity
      },
      className: 'active'
    });
    $scope.last_activity_report.splice(-1, 1);
    $scope.time = Math.floor(UtilityService.randomFloat() * 5000) + 2000;
  };

  $scope.$on('filter-service:filter-changed', function ($event, key) {
    trigfilterChangeorRemove(key);
  });

  $scope.$on('filter-service:filter-removed', function ($event, key) {
    trigfilterChangeorRemove(key);
  });

  function trigfilterChangeorRemove(key) {
    if (_.contains(['from_date', 'to_date'], key)) {
      $scope.showTab('history');
      $scope.updating = false;
    }
  }

  $scope.$on('filter-selection:updated', function () {
    $scope.refresh(true);
  });

  $timeout(function () {
    if (AuthDataService.authData.account && (AuthDataService.authData.account.id === 7)) {
      $scope.time = Math.floor(UtilityService.randomFloat() * 5000) + 2000;
      $scope.stopTime = $interval($scope.refreshActivity, $scope.time);

      $scope.$watch("time", function () {
        $interval.cancel($scope.stopTime);
        $scope.stopTime = $interval($scope.refreshActivity, $scope.time);
      });

      $scope.$on('$destroy', function () {
        $interval.cancel($scope.stopTime);
      });
    }
  }, 5000);
};

app.controller('DashboardController', ['$scope', 'uiGmapGoogleMapApi', 'PropertyService', 'FilterService', '$rootScope',
  '$timeout', '$state', 'AuthDataService', '$filter', '$interval', 'RecurrenceService', 'TemplateService', '$q',
  'ngDialog', 'AccountUserService', 'PermissionService', 'NotificationService', 'ReportService', 'ConfigThemeService', 'UtilityService',
  DashboardController]);
